// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s7-0";
export var fileList = "_s7-2";
export var removeFileButton = "_s7-1";